import { useEffect } from "react";
import { actions as brandedFaresActions } from "../../store/brandedFareOffers/actions.js";
import { clientFetch, appendLanguageOptionParam, appendFeatureAndExperimentParams } from "@flights/client-fetch";
import useClientMetrics from "../../hooks/useClientMetrics.js";
import { useDispatch, useSelector } from "react-redux";
import { getFareOffersWithDetails } from "../../store/brandedFareOffers/selectors.js";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
export default function useFetchBrandedFares(offerToken, isInViewport, isRequestable, isOnSearch, baseOfferFareNameAvailable, carriers) {
    const fareOffers = useSelector(getFareOffersWithDetails);
    const dispatch = useDispatch();
    const { trackClientMetric, trackParameterizedClientMetric } = useClientMetrics();
    const shouldTrackParameterizedClientMetrics = isFeatureRunningClientSide("FLIGHTS_PARAMETERIZED_CLIENT_METRICS");
    const hasFetched = fareOffers[offerToken];
    const shouldFetch = isInViewport && isRequestable && !hasFetched && !!offerToken;
    const fetchBrandedFares = () => {
        const brandedFareParams = new URLSearchParams();
        carriers?.forEach((carrier) => brandedFareParams.append("airlines[]", carrier));
        const url = appendFeatureAndExperimentParams(appendLanguageOptionParam(`/api/brandedFares/${offerToken}?${brandedFareParams.toString()}`));
        clientFetch(url)
            .then((res) => {
            if (isOnSearch && res?.brandedFares?.length > 1) {
                trackClientMetric("branded_fares_on_search_results_available");
                if (shouldTrackParameterizedClientMetrics) {
                    carriers?.forEach((carrier) => {
                        trackParameterizedClientMetric("branded_fares_on_search_results_available.by_carrier.{carrier}", {
                            carrier: carrier.toLowerCase()
                        });
                    });
                }
                if (baseOfferFareNameAvailable) {
                    trackClientMetric("branded_fares_on_search_results_available_and_fare_name_available");
                }
                if (carriers?.includes("FR")) {
                    trackClientMetric("branded_fares_on_search_results_available_ryanair");
                }
            }
            dispatch(brandedFaresActions.fetchSuccess(res.brandedFares, offerToken, res.comparisonTable, res.comparisonTableCompact));
        })
            .catch((err) => {
            if (isOnSearch) {
                trackClientMetric("branded_fares_on_search_results_failed");
            }
            dispatch(brandedFaresActions.fetchError(err, offerToken));
        })
            .finally(() => {
            if (isOnSearch) {
                trackClientMetric("branded_fares_on_search_results_requestable");
                if (shouldTrackParameterizedClientMetrics) {
                    carriers?.forEach((carrier) => {
                        trackParameterizedClientMetric("branded_fares_on_search_results_requestable.by_carrier.{carrier}", {
                            carrier: carrier.toLowerCase()
                        });
                    });
                }
                if (baseOfferFareNameAvailable) {
                    trackClientMetric("branded_fares_on_search_results_requestable_and_fare_name_available");
                }
                if (carriers?.includes("FR")) {
                    trackClientMetric("branded_fares_on_search_results_requestable_ryanair");
                }
            }
        });
    };
    useEffect(() => {
        if (!shouldFetch)
            return;
        dispatch(brandedFaresActions.fetch(offerToken));
        fetchBrandedFares();
    }, [offerToken, shouldFetch]);
}
